import { Col } from "react-bootstrap"
import useLang from "hooks/useLang";
// import barcode from "../../assets/images/services/barcode-individual.jpeg"
import OtherServices from "pages/our-services/OtherServices";
import PopularPost from "pages/tax-updates/PopularPost";

const SideBar = ({ barcode }) => {
  const { lang } = useLang();

  return (
    <Col id="sidebar-popular-post" lg={4} md={5}>
      <div className="ms-lg-4 ps-lg-4 mt-5 mt-lg-0">
        {barcode ? <p style={{ textAlign: "center" }}>{lang.others.scan_me}</p> : null}
        <img src={barcode} alt="" className="barcode" />
        <OtherServices />
        <PopularPost />
      </div>
    </Col>
  );
};

export default SideBar;
